<template>
  <div class="booking-size booking-step js-booking-step" style="display:none" :id="this.$options._componentTag">
    <h1 class="booking-title">House/apartment size</h1>
    <div class="booking-steps__wrap">
      <div class="booking-steps__wrap-holder" v-if="this.getCleaningType.bedrooms || this.getCleaningType.bathrooms">
        <div class="booking-steps__wrap-holder-box">
          <label class="booking-label booking-label--house">Bedrooms <span>+$15 per Bedroom</span></label>
          <range-slider
              id="range-bedroom"
              class="booking-steps__wrap-slider" @change="setBedroom(sliderValueBedrooms)"
              min="1"
              :max="this.getCleaningType.bedrooms ? this.getCleaningType.bedrooms.length : 1"
              step="1"
              v-model="sliderValueBedrooms">
          </range-slider>
          <div class="booking-steps__wrap-holder-nav" v-if="this.getCleaningType.bedrooms">
            <span class="booking-steps__wrap-holder-nav-num" v-for="(item,index) in this.getCleaningType.bedrooms" v-bind:key="index">{{
                item.is_this_studio ? item.studio_label : item.count
              }}</span>
          </div>
        </div>
        <div class="booking-steps__wrap-holder-box" v-if="this.getCleaningType.bathrooms">
          <label class="booking-label booking-label--house">Bathrooms <span>+$15-$20 per Bathroom</span></label>
          <range-slider
              class="booking-steps__wrap-slider" @change="setBathroom(sliderValueBathrooms)"
              min="1"
              :max="this.getCleaningType.bathrooms ? this.getCleaningType.bathrooms.length : 1"
              step="1"
              v-model="sliderValueBathrooms">
          </range-slider>
          <div class="booking-steps__wrap-holder-nav" v-if="this.getCleaningType.bathrooms">
            <span class="booking-steps__wrap-holder-nav-num" v-for="(item,index) in this.getCleaningType.bathrooms" v-bind:key="index">{{
                item.number
              }}</span>
          </div>
        </div>
      </div>
      <div class="booking-side__image booking-location__image">
        <img class="media-item booking-side__image-firefox" :src="imagesPath" alt="animation">
        <div class="anim-holder">
          <div class="anim-container anim-container--03" id="anime-03"></div>
        </div>
      </div>
    </div>
  </div><!-- .booking-size -->
</template>

<script>
import lottieWeb from 'lottie-web';
import RangeSlider from 'vue-range-slider';
// you probably need to import built-in style
import 'vue-range-slider/dist/vue-range-slider.css';
import {mapGetters} from 'vuex';
import Global from '../../../js/shared/global';

export default {
  mounted() {
    this.animation();
    const activeBedroom = Global.readCookie('activeBedroom');
    const activeBathroom = Global.readCookie('activeBathroom');
    this.sliderValueBedrooms = activeBedroom ? parseInt(activeBedroom) : 1;
    this.sliderValueBathrooms = activeBathroom ? parseInt(activeBathroom) : 1;
    if (Global.readCookie('cleaningTypeObj')) {
      this.$store.dispatch('setCleaningType', Global.readCookie('cleaningTypeObj'));
    }
  },
  data() {
    return {
      sliderValueBedrooms: 0,
      sliderValueBathrooms: 0,
      activeProduct: null,
      imagesPath: process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/animations/3.png'
    };
  },
  methods: {
    animation() {
      setTimeout(() => {
        const animContainer = document.getElementById('anime-03');
        const animation = process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/animations/Icon3.json';
          const anim = lottieWeb.loadAnimation({
            container: animContainer,
              animType: 'svg',
              loop: true,
              autoplay: true,
              path: animation,
              renderer: 'svg',
              rendererSettings: {
                progressiveLoad: true,
              },
          });
          anim.play();
      }, 500);
    },
    setBedroom(val) {
      this.$store.dispatch('setBedroom', this.getCleaningType.bedrooms[val - 1]);
      Global.setCookie('activeBedroom', val);
      Global.setCookie('activeBedroomObj', this.getCleaningType.bedrooms[val - 1]);
    },
    setBathroom(val) {
      this.$store.dispatch('setBathroom', this.getCleaningType.bathrooms[val - 1]);
      Global.setCookie('activeBathroom', val);
      Global.setCookie('activeBathroomObj', this.getCleaningType.bathrooms[val - 1]);
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentStep',
      'getCleaningType',
    ])
  },
  components: {
    RangeSlider
  }
};
</script>

<style lang="scss" scoped>
.slider {
  /* overwrite slider styles */
  width: 200px;
}

.booking-label {
  font-size: 20px;
  letter-spacing: 4px;
  margin-bottom: 37px;

  @include mq($lg) {
    margin-bottom: 15px;
  }

  @include mq($md) {
    font-size: 14px;
    margin-bottom: 10px;
  }
}

.booking-steps__wrap-holder {
  max-width: 720px;
  width: 100%;

  @include mq($desk-small) {
    padding-left: 15px;
  }

  @include mq($lap-large) {
    max-width: 650px;
  }

  @include mq($lap-mid) {
    max-width: 550px;
  }

  @include mq($xl) {
    max-width: 49%;
  }

  @include mq($lg) {
    max-width: 100%;
    padding-left: 0;
  }
}

.booking-steps__wrap-slider {
  padding: 0 !important;
  width: 100%;
}

.booking-steps__wrap-holder-nav {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 22px;
}

.booking-steps__wrap-holder-nav-num {
  font-size: 20px;
  font-family: $font-main;
  font-weight: 700;
  font-style: normal;
  letter-spacing: normal;
  line-height: 1.2;
  color: $baby-blue;
  max-width: 9px;

  @include mq($md) {
    font-size: 16px;
  }

  @include mq($xs) {
    letter-spacing: -1px;
    max-width: 13px;
  }
}

.booking-steps__wrap-holder-box {
  margin-top: 80px;

  &:first-child {
    margin-top: 0;
  }

  @include mq($md) {
    margin-top: 60px;
  }
}

.booking-side__image {
  max-width: 500px;
  width: 100%;
  transform: translate(-4px, 0);
  margin: 0 auto;

  @include mq($lap-large) {
    transform: translate(0);
  }

  @include mq($xl) {
    max-width: 40%;
  }

  @include mq($lg) {
    max-width: 300px;
    margin-top: 50px;
    margin-bottom: 30px;
  }
}
</style>
